import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgModule } from '@angular/core';

import { library } from '@fortawesome/fontawesome-svg-core';
import { 
    faAdjust,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faArrowLeft,
    faArrows,
    faArrowsAlt,
    faBars,
    faBookmark,
    faCamera,
    faCaretDown, 
    faCaretLeft,
    faCaretRight,
    faCaretUp,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCrosshairs,
    faDotCircle,
    faEllipsisV,
    faEmptySet,
    faExternalLink,
    faEye,
    faEyeSlash,
    faFillDrip,
    faGlobe,
    faLock,
    faMinus,
    faMousePointer,
    faPause,
    faPencil,
    faPlay,
    faPlus,
    faPortrait,
    faQuestion,
    faRedo,
    faSearch,
    faSquare,
    faTag,
    faTimes,
    faTimesCircle,
    faUndo,
    faUtensilKnife,
    faXRay,
    faEdit,
    faClone,
    faTrashAlt,
    faFont,
    faUserPlus,
    faUser,
    faHistory,
    faFastBackward,
    faBone,
    faHandPointUp,
    faLungs,
    faPlusCircle,
    faPen,
    faLocationArrow,
    faLocationCircle,
    faCompass,
    faCheckCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faTh
} from '@fortawesome/pro-solid-svg-icons';

library.add(faAdjust);
library.add(faAngleDown);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faAngleUp);
library.add(faArrowLeft);
library.add(faArrows);
library.add(faArrowsAlt);
library.add(faBars);
library.add(faBone);
library.add(faCamera);
library.add(faCaretDown);
library.add(faCaretLeft);
library.add(faCaretRight);
library.add(faCaretUp);
library.add(faCheckCircle);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faCircle);
library.add(faClone);
library.add(faCompass);
library.add(faCrosshairs);
library.add(faDotCircle);
library.add(faExclamationCircle);
library.add(faExclamationTriangle);
library.add(faExternalLink);
library.add(faEdit);
library.add(faEllipsisV);
library.add(faEmptySet);
library.add(faEye);
library.add(faEyeSlash);
library.add(faFastBackward);
library.add(faFont);
library.add(faFillDrip);
library.add(faHandPointUp);
library.add(faHistory);
library.add(faLocationArrow);
library.add(faLocationCircle);
library.add(faLock);
library.add(faLungs);
library.add(faMinus);
library.add(faMousePointer);
library.add(faPause);
library.add(faPen);
library.add(faPencil);
library.add(faPlay);
library.add(faPlus);
library.add(faPortrait);
library.add(faQuestion);
library.add(faRedo);
library.add(faSearch);
library.add(faSquare);
library.add(faTag);
library.add(faTh);
library.add(faTimes);
library.add(faTimesCircle);
library.add(faTrashAlt);
library.add(faUndo);
library.add(faUtensilKnife);
library.add(faXRay);
library.add(faGlobe);
library.add(faBookmark);
library.add(faExternalLink);
library.add(faUser);
library.add(faUserPlus);
library.add(faPlusCircle);

@NgModule({
    imports: [
        FontAwesomeModule
    ],
    exports: [
        FontAwesomeModule
    ]
})
export class FontAwesomeConfigModule { }
